// @ts-strict-ignore
import React, { useCallback } from 'react'
import SelfNavSearchCard from 'APP/Converse/SelfNavSearchCard'
import { FlatList } from 'react-native'
import { SearchPlaceResult } from '@dialogue/coredata'
import i18n from 'APP/I18n'
import { useNavigation } from '@react-navigation/native'
import { handleDirections, handleCall } from 'APP/Helpers/SelfNavActions'

export interface SelfNavigationResultsProps {
  specialty: string
  results: SearchPlaceResult[]
}

const SelfNavigationResults = ({ specialty, results }: SelfNavigationResultsProps) => {
  const navigation = useNavigation()

  const handlePress = useCallback(
    (place: SearchPlaceResult) => {
      navigation.navigate('selfNavigationDetail', { place, specialty })
    },
    [navigation, specialty]
  )

  const renderItem = ({ item }: { item: SearchPlaceResult }) => {
    return (
      <SelfNavSearchCard
        key={item.place_id}
        title={item.name}
        address={item.full_address}
        distance={
          item.distance?.kilometers
            ? `${item.distance.kilometers} ${i18n.t('SelfNavSearchCard.distance.metric')}`
            : ''
        }
        rating={item.ratings?.total_count !== 0 ? item.ratings?.average_rating : undefined}
        openStatus={item.opening_hours?.is_open_now}
        closingTime={item.opening_hours?.current_day_closing_time}
        type={specialty}
        onDirections={() => handleDirections(item, specialty)}
        onCall={item.phone_number ? () => handleCall(item, specialty) : undefined}
        onPress={() => handlePress(item)}
      />
    )
  }

  return <FlatList data={results} keyExtractor={(item) => item.place_id} renderItem={renderItem} />
}

export default SelfNavigationResults
